import classNames from "clsx";
import { useTranslations } from "next-intl";
import { useMemo } from "react";
import {
  HiOutlineTrophy,
  HiOutlineMegaphone,
  HiOutlineGlobeAmericas,
  HiOutlineCheckCircle,
  HiOutlineRocketLaunch,
} from "react-icons/hi2";

import { urls } from "@shared/constants";
import { Text } from "@shared/elements";

import { MESSAGE_PREFIX } from "../constants";

type ProductSwitcherProps = {
  className?: string;
  hide?: Array<string>;
};

export default function ProductSwitcher({
  className,
  hide = [],
  ...rest
}: ProductSwitcherProps) {
  const t = useTranslations(`${MESSAGE_PREFIX}ProductSwitcher`);

  const products = useMemo(
    () =>
      [
        {
          id: "submit",
          name: t("openContests"),
          description: t("openContestsDesc"),
          Icon: HiOutlineTrophy,
          href: urls.index,
        },
        {
          id: "curate",
          name: t("contestHosts"),
          description: t("contestHostsDesc"),
          Icon: HiOutlineGlobeAmericas,
          href: "https://www.picter.com/contest-hosting",
        },
        {
          id: "workspace",
          name: "Workspace",
          description: t("workspaceDesc"),
          Icon: HiOutlineCheckCircle,
          href: "https://www.picter.com/workspace",
        },
        {
          id: "advertise",
          name: t("advertise"),
          description: t("advertiseDesc"),
          Icon: HiOutlineMegaphone,
          href: "https://www.picter.com/media",
        },
        {
          id: "brandEngagement",
          name: t("brandEngagement"),
          description: t("brandEngagementDesc"),
          Icon: HiOutlineRocketLaunch,
          href: "https://www.picter.com/brand-engagement",
        },
      ].filter((item) => !hide.includes(item.id)),
    [hide, t],
  );

  return (
    <ul className={classNames("relative grid gap-2", className)} {...rest}>
      {products.map((item) => (
        <li
          key={item.name as string}
          className="p-2 hover:bg-gray-50 rounded-lg"
        >
          <a href={item.href}>
            <div className="group space-x-2 flex items-center justify-start gap-2">
              <div className="w-10 h-10 flex justify-center items-center">
                <item.Icon className="text-gray-900 w-10 h-10" />
              </div>
              <div className="flex flex-col justify-start items-start gap-1">
                <Text weight="medium">{item.name}</Text>
                <Text size="sm" color="muted">
                  {item.description}
                </Text>
              </div>
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
}

ProductSwitcher.messages = [`${MESSAGE_PREFIX}ProductSwitcher`];
